export default __webpack_public_path__ + "static/media/trator.528eef10.png";